<template>
    <div class="d-flex flex-column">
        <loading-state
                v-if="loading"
                centered
                overlay
                title="Loading scanner">
        </loading-state>
        <div class="form-group">
            <label>Scan QR code</label>
            <qrcode-stream @decode="getBookingFromQrCode"></qrcode-stream>
        </div>
        <div class="form-group">
            <label>or enter code</label>
            <input class="form-control" name="code" type="text" v-model="bookingToken" :class="{'is-invalid': error.bookingToken}" v-on:keyup.enter="getBookingFromField()" />
            <div class="invalid-feedback" v-if="error.bookingToken">Your booking code is missing</div>
        </div>
        <button v-if="!loading" v-on:click="getBookingFromField" class="btn continue-btn btn-lg">
            Continue booking
        </button>
        <button v-if="loading" class="btn continue-btn btn-lg disabled">
            Loading...
        </button>
    </div>
</template>

<script>
import router from "@/router";
import {mapActions} from "vuex";
import { QrcodeStream } from 'vue-qrcode-reader'

export default {
    name: "BookingCompletionForm",

    components: {
        QrcodeStream,
    },

    data() {
        return {
            bookingToken: "",
            error: {
                bookingToken: false
            },
            invalidReferenceError: "",
            invalidReferenceErrorHeader: "",
            loading: false,
            referencePresent: true
        }
    },

    methods: {
        ...mapActions([
            'retrieveBookingByToken'
        ]),

        getBooking(token) {
            this.loading = true;
            this.retrieveBookingByToken(token).then(() => {
                router.push({name: 'paymentOptions'});
            }).catch(() => {
                this.loading = false;
            });
        },

        getBookingFromField() {
            this.error.bookingToken = false;
            this.loading = true;

            if (this.bookingToken) {
                return this.getBooking(this.bookingToken);
            }

            this.error.bookingToken = true;
        },

        getBookingFromQrCode(data) {
            let token = data.toString();
            if (token.indexOf('=') !== -1) {
                token = token.split('=').pop();
            }

            if(token) {
                this.getBooking(token)
            }
        },
    }
}
</script>

<style scoped>

</style>